import React from 'react';
import RateHalf from '../../../../../assets/img/button-icons/rate-half.svg';
import RateFull from '../../../../../assets/img/button-icons/rate-full.svg';
import RateEmpty from '../../../../../assets/img/button-icons/rate-empty.svg';

const FeedbackRate = ({ title, type, chip, rate }) => {
  const renderRate = (rate) => {
    const rateArray = [];
    const fullStars = Math.floor(rate);
    const hasHalfStar = rate % 1 >= 0.5;

    for (let i = 0; i < 5; i++) {
      if (i < fullStars) {
        rateArray.push(<img key={i} src={RateFull} alt="rate-full" />);
      } else if (i === fullStars && hasHalfStar) {
        rateArray.push(<img key={i} src={RateHalf} alt="rate-half" />);
      } else {
        rateArray.push(<img key={i} src={RateEmpty} alt="rate-empty" />);
      }
    }
    return rateArray;
  };
  return (
    <div className="rate-container">
      <div className="d-flex gap-1">
        <div className="rate-title">{`${title}:`}</div>
        <div className="d-flex gap-2">
          <div className="rate-type">{type}</div>
          <div className="rate-chip">{chip}</div>
        </div>
      </div>
      <div className="d-flex gap-1 mt-2">{renderRate(rate)}</div>
    </div>
  );
};

export default FeedbackRate;
